// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__TQx6v","header":"Messages_header__2zZGN"};